import { Component, OnInit, HostBinding, 
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';

import { SuppliersData, SuppliersService }  from './Suppliers.service';


@Component({
  template: require('./SuppliersDetails.component.html'),
  providers: [SuppliersService
	
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class SuppliersDetailsComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }
  
	objSuppliers: SuppliersData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	

	constructor(private route: ActivatedRoute, 
		private router: Router, 
		private toastr: ToastsManager,
		private SuppliersService: SuppliersService

	) {
		// this.id = parseInt(params.get('id'));
		this.objSuppliers = new SuppliersData();
	}

	ngOnInit() {
		this.route.params
		// (+) converts string 'id' to a number
		// .switchMap((params: Params) => this.SuppliersService.getByID(+params['id']))
		.switchMap((params: Params) => this.SuppliersService.getByID(params['id']))
		.subscribe((item: SuppliersData) => this.objSuppliers = item);
		this.getLookups();
	}

	deleteSuppliers(id: number) {
		if (window.confirm('Are you sure you want to delete this Suppliers?') == true)
		{
			this.SuppliersService.deleteSuppliers(this.objSuppliers.SupplierID.toString())
			.subscribe(record => this.router.navigate(['/Suppliers']),
				error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { console.log('Suppliers record deleted successfully...'); }
			);
		}
	}
	gotoSuppliersEdit() {
		this.router.navigate(['/Suppliers', this.objSuppliers.SupplierID]);
	}

	gotoSuppliers() {
		this.router.navigate(['/Suppliers']);
	}


	getLookups() {

	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Suppliers/SuppliersDetails.component.ts